export default {
  methods: {
    getMerchantParams (extra = {}) {
      const userInfo = this.$store.getters.userInfo || {}
      return {
        merchantId: userInfo.merchantId,
        character: userInfo.merchantLoginType,
        operatorId: userInfo.superiorBossId,
        ...extra
      }
    },
    buildLineParams (record) {
      return this.getMerchantParams({
        lineId: record.lineId,
        title: record.title || ''
      })
    },
    buildListParams (params) {
      const { limitDto = {}, ...query } = params
      return this.getMerchantParams({
        ...query,
        pageNum: limitDto.pageNum || 1,
        pageSize: limitDto.pageSize || 10
      })
    },
    normalizePageResult (res) {
      const page = res || {}
      return {
        data: page.list || [],
        totalCount: page.total || 0,
        pageCount: page.pages || 1
      }
    },
    refreshTable () {
      this.$refs.table?.refresh(false)
    },
    requestPost (url, data, { successMsg, failMsg, refresh = true } = {}) {
      return this.getHttpServices()
        .getSourceService()
        .post(url, data)
        .then(() => {
          if (successMsg) this.$message.success(successMsg)
          if (refresh) this.refreshTable()
        })
        .catch(err => {
          this.$message.error((err && err.msg) || failMsg || '操作失败，请重试')
        })
    }
  }
}
